(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class NdHeader extends HTMLElement {
    connectedCallback() {
      this.searchPanel = this.querySelector('[data-search]');
      this.searchToggle = this.querySelector('[data-search-toggle]');
      this.mobileMenu = document.getElementById('nd-mobile-menu');

      const setHeight = () => {
        document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      };
      setHeight();
      window.addEventListener('resize', setHeight);

      const onScroll = () => this.classList.toggle('nd-header--scrolled', window.scrollY > 4);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });

      if (this.searchToggle && this.searchPanel) {
        this.searchToggle.addEventListener('click', () => {
          const willOpen = this.searchPanel.hasAttribute('hidden');
          this.searchPanel.toggleAttribute('hidden', !willOpen);
          this.searchToggle.setAttribute('aria-expanded', String(willOpen));
          if (willOpen) this.searchPanel.querySelector('input[name="q"]').focus();
        });
      }

      const openMenu = () => {
        if (!this.mobileMenu) return;
        this.mobileMenu.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      };
      const closeMenu = () => {
        if (!this.mobileMenu) return;
        this.mobileMenu.setAttribute('hidden', '');
        document.body.style.overflow = '';
      };

      this.querySelector('[data-menu-open]')?.addEventListener('click', openMenu);
      this.mobileMenu?.querySelectorAll('[data-menu-close]').forEach((el) => el.addEventListener('click', closeMenu));

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        closeMenu();
        if (this.searchPanel && !this.searchPanel.hasAttribute('hidden')) {
          this.searchPanel.setAttribute('hidden', '');
          this.searchToggle?.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  if (!customElements.get('nd-header')) {
    customElements.define('nd-header', NdHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
